<template>
  <div class="card-section">
    <div class="text-section-header">Related projects</div>
    <div class="related-projects">
      <div
        v-for="project in relatedProjects"
        :key="project.ID"
        class="related-projects__item"
        @click="() => handleClick(project.ID)"
      >
        {{ project['post_title'] }}
      </div>
    </div>
  </div>
</template>

<script>
// vuex
// library
// internal
// components
export default {
  name: 'RelatedProjects',
  props: {
    relatedProjects: {
      required: true,
      type: Array
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleClick(ID) {
      this.$router.push({ name: 'SingleProject', params: { id: ID } })
      this.$router.go()
    }
  }
}
</script>
<style lang="scss" scoped>
.related-projects {
  &__item {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
